import { PUSH_EVENT } from './constants'

export const pushEvent = (category, payload) => ({ type: PUSH_EVENT, category, payload })



// WEBPACK FOOTER //
// ./src/hocs/TrackingHOC/actions.js